import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { BannersRoutesModule } from './banners.routes';
import { BannersComponent } from './banners.component';
import { DefaultCardComponent } from './default-card/default-card.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TestUserCardComponent } from './test-user/test-user-card.component';
import { MeNPSComponent } from './nps/nps.component';

@NgModule({
    imports: [
        BaseModule,
        BannersRoutesModule,
        StoryBlokLinkModule,
        ModalModule.forRoot(),
        // BannersComponent,
        // TestUserCardComponent
    ],
    declarations: [
        DefaultCardComponent,
        TestUserCardComponent,
        MeNPSComponent,
        BannersComponent
    ],
    exports: [
        BannersComponent,
        MeNPSComponent
    ]
})
export class BannersModule { }
